import { ALL_ASSET_TYPES } from '@nile/rmm/src/constants';
import { ALL_TABLES, toast } from '@nile/components';
import { useContext } from 'react';
import { executedScriptsDefaultListInfo } from '@nile/rmm/src/modules/asset-management/components/sub-pages/executed-scripts/constants';
import RMMContext from '@nile/rmm/src/modules/common/contexts/RMMContext';

const ALL_MONITORED_ASSETS = [
  ALL_ASSET_TYPES.ALL_ASSETS,
  ALL_ASSET_TYPES.ALL_MONITORED_ASSET,
  ALL_ASSET_TYPES.ALL_NON_MONITORED_ASSET,
  ALL_ASSET_TYPES.PRINTER_ASSET,
  ALL_ASSET_TYPES.FIREWALL_ASSET,
  ALL_ASSET_TYPES.SWITCH_ASSET,
  ALL_ASSET_TYPES.ROUTER_ASSET,
  ALL_ASSET_TYPES.UPS,
  ALL_ASSET_TYPES.LOAD_BALANCER,
  ALL_ASSET_TYPES.POWER_DISTRIBUTION_UNIT,
  ALL_ASSET_TYPES.STORAGE,
  ALL_ASSET_TYPES.WAN_ACCELERATOR,
  ALL_ASSET_TYPES.WIRELESS_ACCESS_POINT,
  ALL_ASSET_TYPES.WIRELESS_LAN_CONTROLLER,
  ALL_ASSET_TYPES.VOIP,
  ALL_ASSET_TYPES.IP_CAMERA,
  ALL_ASSET_TYPES.NAS,
  ALL_ASSET_TYPES.SERVER_HARDWARE_CONTROLLER_ASSET,
  ALL_ASSET_TYPES.WAN_ROUTER_ASSET,
  ALL_ASSET_TYPES.NETWORK_VIDEO_RECORDER_ASSET,
  ALL_ASSET_TYPES.ETHERNET_IP_BRIDGE_ASSET,
  ALL_ASSET_TYPES.TEMPERATURE_SENSOR_ASSET,
  ALL_ASSET_TYPES.DOMAIN_CONTROLLER_ASSET,
  ALL_ASSET_TYPES.VMWARE_ESXI_ASSET,
  ALL_ASSET_TYPES.ENVIRONMENTAL_MONITORING_DEVICE_ASSET,
  ALL_ASSET_TYPES.SERIAL_DEVICE_SERVER_ASSET,
  ALL_ASSET_TYPES.PRESENTATION_GATEWAY_ASSET,
  ALL_ASSET_TYPES.VOIP_GATEWAY_ASSET,
  ALL_ASSET_TYPES.USB_HUB_ASSET,
  ALL_ASSET_TYPES.X_TERMINAL_ASSET,
  ALL_ASSET_TYPES.ETHERNET_GATEWAY_ASSET,
  ALL_ASSET_TYPES.PBX_ASSET,
  ALL_ASSET_TYPES.ETHERNET_CARD_ASSET,
  ALL_ASSET_TYPES.AUDIO_CODEC_ASSET,
  ALL_ASSET_TYPES.RF_TRANSMITTER_ASSET,
  ALL_ASSET_TYPES.TAPE_LIBRARY_ASSET,
  ALL_ASSET_TYPES.KVM_SWITCH_ASSET,
  ALL_ASSET_TYPES.ZERO_CLIENT_ASSET,
  ALL_ASSET_TYPES.BARCODE_PRINTER_ASSET,
  ALL_ASSET_TYPES.SAN_ASSET
];

function fetchTableFromSubtype(viewSubType) {
  if (ALL_MONITORED_ASSETS.includes(viewSubType)) {
    return ALL_TABLES.allMonitorAssetTable;
  }
  return ALL_TABLES.asset;
}

export function getTableName(activeView, toolbarConfig, tab) {
  const { viewType, viewSubType } = activeView || {};
  const { module } = toolbarConfig || {};
  const context = useContext(RMMContext);
  const { selectedAssetClass } = context || {};

  if (viewType === 'POLICY_CATEGORY' && module === 'client-asset-view') {
    return ALL_TABLES.clientDeviceCategory;
  }

  switch (module) {
    case 'asset-view':
    case 'client-asset-view':
    case 'portal-asset-view':
    case 'asset-group':
    case 'device-category':
      return fetchTableFromSubtype(viewSubType);

    case 'network-view':
      if (tab === '6002') return ALL_TABLES.networkListTable;
      if (tab === '6003')
        return ALL_TABLES.scannedAssetListTable + '-' + `${tab}`;
      return fetchTableFromSubtype(viewSubType);

    case 'alert':
      return ALL_TABLES.alert;

    case 'patch':
      return `${ALL_TABLES.patch}-${selectedAssetClass}`;

    case 'executed-scripts':
      return ALL_TABLES.executedScriptList;
    default:
      return '';
  }
}

export const DEFAULT_ADVANCE_FILTERS = {
  'executed-scripts': executedScriptsDefaultListInfo.condition
};

export function assetInAllMonitoredAssets(asset) {
  return ALL_MONITORED_ASSETS.includes(asset);
}

export function validateDependency(
  conditionPayload: any,
  dependentAttributes: (attr: string) => boolean,
  requiredAttributes: (attr: string) => boolean
) {
  if (!conditionPayload?.operands) {
    return { isValid: true, missingGroups: [] };
  }

  const missingGroups: number[] = [];

  conditionPayload.operands.forEach((operandGroup: any, index: number) => {
    if (operandGroup.operands?.length > 0) {
      const hasDependentAttributes = operandGroup.operands.some((op: any) =>
        dependentAttributes(op.attribute)
      );
      const hasRequiredAttributes = operandGroup.operands.some((op: any) =>
        requiredAttributes(op.attribute)
      );
      if (hasDependentAttributes && !hasRequiredAttributes) {
        missingGroups.push(index);
      }
    }
  });

  return { isValid: missingGroups.length === 0, missingGroups };
}

export function createSoftwareVersionValidator({
  intl,
  setPrefilledRule,
  dependentAttributes,
  requiredAttributes,
  errorMessageId,
  prefilledRule
}: {
  intl: any;
  setPrefilledRule: (rule: any) => void;
  dependentAttributes: (attr: string) => boolean;
  requiredAttributes: (attr: string) => boolean;
  errorMessageId: string;
  prefilledRule: any;
}) {
  return (conditionPayload: any) => {
    const validationResult = validateDependency(
      conditionPayload,
      dependentAttributes,
      requiredAttributes
    );

    if (!validationResult.isValid) {
      toast(
        'error',
        intl.formatMessage({
          id: errorMessageId
        }),
        intl.locale
      );

      setPrefilledRule({
        ...prefilledRule,
        targetGroupIndex: validationResult.missingGroups[0]
      });

      return false;
    }

    return true;
  };
}
